/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 11:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Modal } from '@shopify/polaris';
import { WithI18nProps, withI18n } from '@shopify/react-i18n';

type ComposedProps = Props & WithI18nProps;

class RequestSuccessModal extends Component<ComposedProps> {
  state = {
    displayThemeList: false,
    displayRequestCustomization: false,
    themeList: [],
    selectedFiles: []
  };

  render() {
    const { active, handleChangeModal, i18n } = this.props;

    return (
      <Modal
        open={active}
        onClose={handleChangeModal}
        title={i18n.translate('AdminHTML.DashboardV3.InstallStatusBanner.successModal.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.gotIt'),
          onAction: handleChangeModal
        }}>
        <Modal.Section>
          <p>
            {i18n.translate('AdminHTML.DashboardV3.InstallStatusBanner.successModal.content01')}
          </p>
          <p style={{ marginTop: '20px' }}>
            {i18n.translate('AdminHTML.DashboardV3.InstallStatusBanner.successModal.content02', {
              email: <strong>support@boostcommerce.net</strong>
            })}
          </p>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(RequestSuccessModal);
